import { useEffect, useState } from 'react';
export function useOrganizationAutoSelect(userId, currentOrgId, availableOrgIds, applyOrg) {
    const [isAutoSelecting, setIsAutoSelecting] = useState(false);
    useEffect(() => {
        if (!userId || currentOrgId || isAutoSelecting || !availableOrgIds.length)
            return;
        setIsAutoSelecting(true);
        applyOrg(availableOrgIds[0]);
        setIsAutoSelecting(false);
    }, [userId, currentOrgId, isAutoSelecting, availableOrgIds, applyOrg]);
    return { isAutoSelecting };
}
//# sourceMappingURL=useOrganizationAutoSelect.js.map